// extracted by mini-css-extract-plugin
export default {"default-card":"DefaultCard_default-card__Gbf3o"};